export default class FeeScheduleCategoryDescription {
  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: FeeScheduleCategoryDescription): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): FeeScheduleCategoryDescription {
    return new FeeScheduleCategoryDescription("");
  }

  public fromJSON(value: string): FeeScheduleCategoryDescription {
    return new FeeScheduleCategoryDescription(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): FeeScheduleCategoryDescription {
    return new FeeScheduleCategoryDescription(this.value);
  }
}
